export const getAppVersion = () => {
  console.log(`Current Version %c${process.env.REACT_APP_VERSION}`, 'color: yellow; background:#e18;')
  return process.env.REACT_APP_VERSION
}
  